import metaCache from "flow/utils/metaCache";

function isjqXhrObject(jqXhr: any): jqXhr is JQuery.jqXHR {
    return jqXhr !== undefined && jqXhr !== null && jqXhr.readyState !== undefined && jqXhr.status !== undefined;
}

function isBadRequest(jqXhr: JQuery.jqXHR): boolean {
    return jqXhr.status === 460;
}

function isBusinessException(jqXhr: JQuery.jqXHR): boolean {
    return jqXhr.status === 461;
}

function isForbidden(jqXhr: JQuery.jqXHR): boolean {
    return jqXhr.status === 403;
}

function isTimeout(jqXhr: JQuery.jqXHR): boolean {
    return jqXhr.status === 0 && jqXhr.statusText === "timeout";
}

function isConnectionProblem(jqXhr: JQuery.jqXHR): boolean {
    return hasBrokenConnection(jqXhr) || hasLostSession(jqXhr);
}

function hasBrokenConnection(jqXhr: JQuery.jqXHR): boolean {
    return (
        jqXhr.readyState == 0 && jqXhr.status == 0 && jqXhr.statusText == "error" && (jqXhr as any)._heartbeatTimedOut
    );
}

function hasLostSession(jqXhr: JQuery.jqXHR): boolean {
    return (
        jqXhr.readyState == 0 && jqXhr.status == 0 && jqXhr.statusText == "error" && !(jqXhr as any)._heartbeatTimedOut
    );
}

function getErrorMessageFromResponse(jqXhr: JQuery.jqXHR, message: string): string {
    if (jqXhr.responseText) {
        try {
            const responseObj = JSON.parse(jqXhr.responseText);
            if (
                responseObj &&
                typeof responseObj.exceptionMessage === "string" &&
                responseObj.exceptionMessage.trim() !== ""
            ) {
                return responseObj.exceptionMessage;
            }
        } catch (e) {
            // Ignore JSON parse-error, proceed to the next step
        }

        if (jqXhr.responseText.trim() !== "") {
            return jqXhr.responseText;
        }
    }

    if (message && message.trim() !== "" && message.trim().toLowerCase() !== "error") {
        return message;
    }

    return metaCache.translate("FlowHtml.Translations.PleaseTryAgainOrContactAdmin");
}

export default {
    isjqXhrObject,
    isBadRequest,
    isBusinessException,
    isForbidden,
    isTimeout,
    isConnectionProblem,
    hasBrokenConnection,
    hasLostSession,
    getErrorMessageFromResponse
};
